<template lang="pug"></template>

<script>
export default {
    name: 'BotaoTerritorio',
    componentOptions: {
        title: 'Territorio',
        actions: [
            [
                {
                    name: 'Território',
                    iconClass: 'lyra-icon lyra-territorio',
                    showView: false,
                    action: 'abrirTerritorio',
                    route: 'Territorio'
                }
            ]
        ]
    },

    methods: {
        abrirTerritorio() {
            if (this.$route.name !== 'Territorio') {
                this.$router.push({ name: 'Territorio' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
